"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _chunkMQ5AGG7Cjs = require('./chunk-MQ5AGG7C.js');var _chunkEIRIPU3Cjs = require('./chunk-EIRIPU3C.js');var _chunkB6MCDPORjs = require('./chunk-B6MCDPOR.js');var _chunkW2GTXT47js = require('./chunk-W2GTXT47.js');var _chunkOL2KRAIPjs = require('./chunk-OL2KRAIP.js');var _chunkUE6IS67Fjs = require('./chunk-UE6IS67F.js');var _react = require('react');var _styled = require('@emotion/styled'); var _styled2 = _interopRequireDefault(_styled);var _jsxruntime = require('react/jsx-runtime');var x=(t,e)=>t==="success"?e.palette.GREEN:t==="error"?e.palette.RED:e.palette.BASE_FILL,A=(t,e)=>`${t}: ${e.measurements.spacing(20)}`,B=(t,e)=>t==="left"||t==="right"?`${t}: ${e.measurements.spacing(20)}`:"left: 50%; transform: translate(-50%, 0)",k=_styled2.default.div`
  position: fixed;
  opacity: 0;
  min-width: fit-content;
  padding: ${t=>t.theme.measurements.spacing(8)};
  display: flex;
  align-items: center;
  background: ${t=>x(t.$type,t.theme)};
  gap: ${t=>t.theme.measurements.spacing(6)};
  border-radius: ${t=>t.theme.measurements.shape(2)};
  color: ${t=>t.theme.palette.BASE_ONE};
  transition: 0.25s;
  ${t=>A(t.$vertical,t.theme)};
  ${t=>B(t.$horizontal,t.theme)};
  box-shadow: 0px ${t=>t.theme.measurements.spacing(6)}
    ${t=>t.theme.measurements.spacing(12)}
    ${t=>t.theme.mode==="light"?t.theme.palette.BLACK:t.theme.palette.WHITE}0F;

  &.open {
    opacity: 1;
  }
`,N=_styled2.default.call(void 0, _chunkMQ5AGG7Cjs.b)`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  color: ${t=>t.theme.palette.BASE_ONE};
`,R=_styled2.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  svg {
    color: ${t=>t.theme.palette.BASE_ONE};
  }
`,z=_styled2.default.button`
  background: transparent;
  padding: 0;
  outline: none;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: flex-end;
  cursor: pointer;
`,L=t=>t==="success"||t==="generic"?_jsxruntime.jsx.call(void 0, _chunkW2GTXT47js.b,{height:20,width:20}):_jsxruntime.jsx.call(void 0, _chunkEIRIPU3Cjs.b,{height:20,width:20});function S(t){let{children:e,type:a="generic",className:h,ariaLabel:T,dataTestId:d,vertical:g="top",horizontal:$="center",open:i=!1,hideIcon:y=!1,close:o,duration:r=6e3,icon:E}=t,v=_react.useRef.call(void 0, null),O=_chunkOL2KRAIPjs.b.call(void 0, ),w=_react.useMemo.call(void 0, ()=>L(a),[a]);return _chunkUE6IS67Fjs.a.call(void 0, v,o||(()=>null)),_react.useEffect.call(void 0, ()=>{if(i&&r&&o){let C=setTimeout(()=>{o()},r);return()=>clearTimeout(C)}return()=>null},[i,o,r]),_jsxruntime.jsxs.call(void 0, k,{className:`aquilla-toast toast ${h||""} ${i?"open":""}`,"aria-label":T,"data-testid":d,$type:a,$horizontal:$,$vertical:g,children:[_jsxruntime.jsx.call(void 0, R,{children:E||w}),_jsxruntime.jsx.call(void 0, N,{as:"div",variant:"h6",children:e}),o&&!y?_jsxruntime.jsx.call(void 0, z,{onClick:o,children:_jsxruntime.jsx.call(void 0, _chunkB6MCDPORjs.b,{height:20,width:20,color:O.BASE_ONE})}):""]})}var K=S;exports.a = K;
